import { API } from 'aws-amplify';
import Axios from 'axios';
import { CustomText, FormControl } from 'components';
import classNames from 'lib/classNames';
import { set } from 'lodash';
import React, { useEffect, useState, Fragment } from 'react';

export default function GoalImage({ context, goal,show_badges, setBadgeType, setBadgeImage, index }) {
    const { reward_type } = goal;
    const id = `goal-badge-${index}`;
    const [previewImage, setPreviewImage] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(goal.badge?.image || null);
    const [hasPreview, setHasPreview] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    async function uploadImage(e) {
        const file = e.target.files[0];
        if(!file) return;
        setIsUploading(true);
        const reader = new FileReader();
        reader.onload = async () => {
            try {
                setPreviewImage(reader.result);
                setUploadedImage(reader.result);
                const attachment = reader.result;
                const fileName = file.name;
                const response = await API.post('API_GATEWAY_NEW', '/uploadImage', {
                    body: { fileName, attachment }
                });
                setBadgeImage(response.public_url);
                setIsUploading(false);
            } catch (error) {
                setPreviewImage(null);
                setUploadedImage(null);
                setIsUploading(false);
            }
        };
        reader.readAsDataURL(file);
    }

    useEffect(
        () => {
            setHasPreview(previewImage || uploadedImage);
        },
        [previewImage, uploadedImage]
    );

    return (
        <Fragment>
            <FormControl
                className={!show_badges && 'hidden'}
                // withSwitch={[context, `settings.add_to_unlock.goals.${index}.badge.enabled`]}
                label="badge"
                info="Add add an eye catching image to display for the reward. Selected option will automatically adopt primary bar colors"
            >
                <div
                    className={classNames('flex space-x-2 items-center')}
                >
                    <Circle goal={goal} setBadgeType={setBadgeType} index={1}>
                        <label
                            htmlFor={id}
                            className={classNames(
                                'flex flex-col items-center justify-center w-full h-full cursor-pointer bg-cover bg-center rounded-full'
                            )}
                            style={{
                                backgroundImage: hasPreview
                                    ? `url(${uploadedImage || previewImage})`
                                    : undefined,
                                opacity: isUploading ? 0.5 : 1
                            }}
                        >
                            <span
                                style={{ fontSize: '10px' }}
                                className={classNames('mb-1', {
                                    hidden: hasPreview || isUploading
                                })}
                            >
                                Upload Image
                            </span>
                            <svg
                                width="14"
                                className={classNames({
                                    hidden: hasPreview || isUploading
                                })}
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0 17H14V15H0V17ZM0 7H4V13H10V7H14L7 0L0 7Z"
                                    fill="currentColor"
                                />
                            </svg>
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                data-icon="spinner-third"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                className={classNames('w-5 h-5 fa-spin', { hidden: !isUploading })}
                            >
                                <path
                                    fill="currentColor"
                                    d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z"
                                />
                            </svg>
                        </label>
                        <input
                            type="file"
                            id={id}
                            className={classNames('hidden')}
                            onChange={uploadImage}
                        />
                    </Circle>
                    <Option goal={goal} setBadgeType={setBadgeType} />
                </div>
            </FormControl>
            <CustomText
                className={!show_badges && 'hidden'}
                withSwitch={[context, `settings.add_to_unlock.goals.${index}.badge.show_text`]}
                context={context}
                label="Goal text"
                path={`settings.add_to_unlock.goals.${index}.badge.text`}
                text={goal.badge?.text}
                hasColor={true}
            />
        </Fragment>
    );
}

function Circle({ children, className, goal, setBadgeType, index }) {
    const selected = goal.badge?.type === index;

    return (
        <button
            style={{ fontSize: '11px', color: !selected && '#A3AEBE' }}
            onClick={() => setBadgeType(index)}
            className={classNames(
                'cursor-pointer w-16 h-16 outline-none focus:outline-none flex flex-col items-center justify-center rounded-full text-sm font-semibold text-center',
                className,
                selected ? 'border-2' : 'border',
                { 'border-blue-500 text-blue-500': selected }
            )}
        >
            {children}
        </button>
    );
}

function Option({ goal, setBadgeType }) {
    const { reward_type } = goal;
    switch (reward_type) {
        case 'discount':
            return (
                <Circle goal={goal} setBadgeType={setBadgeType} index={2}>
                    <span>..%</span>
                    <span>Off</span>
                </Circle>
            );
        case 'free_shipping':
            return (
                <Fragment>
                    <Circle goal={goal} setBadgeType={setBadgeType} index={2}>
                        <span style={{ fontSize: '8px' }} className={classNames('mb-1')}>
                            Free shipping
                        </span>
                        <svg
                            width="22"
                            height="14.67"
                            viewBox="0 0 33 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.82105 13.0625L2.77895 11H10.0737L9.24 8.9375H2.43158L1.38947 6.875H12.2274L11.3937 4.8125H1.19495L0 2.75H5.21053C5.21053 2.02065 5.50331 1.32118 6.02446 0.805456C6.54561 0.289731 7.25245 0 7.98947 0H24.6632V5.5H28.8316L33 11V17.875H30.2211C30.2211 18.969 29.7819 20.0182 29.0002 20.7918C28.2184 21.5654 27.1582 22 26.0526 22C24.9471 22 23.8868 21.5654 23.1051 20.7918C22.3234 20.0182 21.8842 18.969 21.8842 17.875H16.3263C16.3263 18.969 15.8871 20.0182 15.1054 20.7918C14.3237 21.5654 13.2634 22 12.1579 22C11.0524 22 9.99211 21.5654 9.21038 20.7918C8.42865 20.0182 7.98947 18.969 7.98947 17.875H5.21053V13.0625H3.82105ZM26.0526 19.9375C26.6054 19.9375 27.1355 19.7202 27.5264 19.3334C27.9173 18.9466 28.1368 18.422 28.1368 17.875C28.1368 17.328 27.9173 16.8034 27.5264 16.4166C27.1355 16.0298 26.6054 15.8125 26.0526 15.8125C25.4999 15.8125 24.9697 16.0298 24.5789 16.4166C24.188 16.8034 23.9684 17.328 23.9684 17.875C23.9684 18.422 24.188 18.9466 24.5789 19.3334C24.9697 19.7202 25.4999 19.9375 26.0526 19.9375ZM28.1368 7.5625H24.6632V11H30.8602L28.1368 7.5625ZM12.1579 19.9375C12.7107 19.9375 13.2408 19.7202 13.6317 19.3334C14.0225 18.9466 14.2421 18.422 14.2421 17.875C14.2421 17.328 14.0225 16.8034 13.6317 16.4166C13.2408 16.0298 12.7107 15.8125 12.1579 15.8125C11.6051 15.8125 11.075 16.0298 10.6841 16.4166C10.2933 16.8034 10.0737 17.328 10.0737 17.875C10.0737 18.422 10.2933 18.9466 10.6841 19.3334C11.075 19.7202 11.6051 19.9375 12.1579 19.9375Z"
                                fill="currentColor"
                            />
                        </svg>
                    </Circle>
                    <Circle goal={goal} setBadgeType={setBadgeType} index={3}>
                        <svg
                            width="33"
                            height="22"
                            viewBox="0 0 33 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.82105 13.0625L2.77895 11H10.0737L9.24 8.9375H2.43158L1.38947 6.875H12.2274L11.3937 4.8125H1.19495L0 2.75H5.21053C5.21053 2.02065 5.50331 1.32118 6.02446 0.805456C6.54561 0.289731 7.25245 0 7.98947 0H24.6632V5.5H28.8316L33 11V17.875H30.2211C30.2211 18.969 29.7819 20.0182 29.0002 20.7918C28.2184 21.5654 27.1582 22 26.0526 22C24.9471 22 23.8868 21.5654 23.1051 20.7918C22.3234 20.0182 21.8842 18.969 21.8842 17.875H16.3263C16.3263 18.969 15.8871 20.0182 15.1054 20.7918C14.3237 21.5654 13.2634 22 12.1579 22C11.0524 22 9.99211 21.5654 9.21038 20.7918C8.42865 20.0182 7.98947 18.969 7.98947 17.875H5.21053V13.0625H3.82105ZM26.0526 19.9375C26.6054 19.9375 27.1355 19.7202 27.5264 19.3334C27.9173 18.9466 28.1368 18.422 28.1368 17.875C28.1368 17.328 27.9173 16.8034 27.5264 16.4166C27.1355 16.0298 26.6054 15.8125 26.0526 15.8125C25.4999 15.8125 24.9697 16.0298 24.5789 16.4166C24.188 16.8034 23.9684 17.328 23.9684 17.875C23.9684 18.422 24.188 18.9466 24.5789 19.3334C24.9697 19.7202 25.4999 19.9375 26.0526 19.9375ZM28.1368 7.5625H24.6632V11H30.8602L28.1368 7.5625ZM12.1579 19.9375C12.7107 19.9375 13.2408 19.7202 13.6317 19.3334C14.0225 18.9466 14.2421 18.422 14.2421 17.875C14.2421 17.328 14.0225 16.8034 13.6317 16.4166C13.2408 16.0298 12.7107 15.8125 12.1579 15.8125C11.6051 15.8125 11.075 16.0298 10.6841 16.4166C10.2933 16.8034 10.0737 17.328 10.0737 17.875C10.0737 18.422 10.2933 18.9466 10.6841 19.3334C11.075 19.7202 11.6051 19.9375 12.1579 19.9375Z"
                                fill="currentColor"
                            />
                        </svg>
                    </Circle>
                </Fragment>
            );
            case 'manual':
            return (
                <Fragment>
                    <Circle goal={goal} setBadgeType={setBadgeType} index={2}>
                        <span style={{ fontSize: '8px' }} className={classNames('mb-1')}>
                            Express shipping
                        </span>
                        <svg
                            width="22"
                            height="14.67"
                            viewBox="0 0 33 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.82105 13.0625L2.77895 11H10.0737L9.24 8.9375H2.43158L1.38947 6.875H12.2274L11.3937 4.8125H1.19495L0 2.75H5.21053C5.21053 2.02065 5.50331 1.32118 6.02446 0.805456C6.54561 0.289731 7.25245 0 7.98947 0H24.6632V5.5H28.8316L33 11V17.875H30.2211C30.2211 18.969 29.7819 20.0182 29.0002 20.7918C28.2184 21.5654 27.1582 22 26.0526 22C24.9471 22 23.8868 21.5654 23.1051 20.7918C22.3234 20.0182 21.8842 18.969 21.8842 17.875H16.3263C16.3263 18.969 15.8871 20.0182 15.1054 20.7918C14.3237 21.5654 13.2634 22 12.1579 22C11.0524 22 9.99211 21.5654 9.21038 20.7918C8.42865 20.0182 7.98947 18.969 7.98947 17.875H5.21053V13.0625H3.82105ZM26.0526 19.9375C26.6054 19.9375 27.1355 19.7202 27.5264 19.3334C27.9173 18.9466 28.1368 18.422 28.1368 17.875C28.1368 17.328 27.9173 16.8034 27.5264 16.4166C27.1355 16.0298 26.6054 15.8125 26.0526 15.8125C25.4999 15.8125 24.9697 16.0298 24.5789 16.4166C24.188 16.8034 23.9684 17.328 23.9684 17.875C23.9684 18.422 24.188 18.9466 24.5789 19.3334C24.9697 19.7202 25.4999 19.9375 26.0526 19.9375ZM28.1368 7.5625H24.6632V11H30.8602L28.1368 7.5625ZM12.1579 19.9375C12.7107 19.9375 13.2408 19.7202 13.6317 19.3334C14.0225 18.9466 14.2421 18.422 14.2421 17.875C14.2421 17.328 14.0225 16.8034 13.6317 16.4166C13.2408 16.0298 12.7107 15.8125 12.1579 15.8125C11.6051 15.8125 11.075 16.0298 10.6841 16.4166C10.2933 16.8034 10.0737 17.328 10.0737 17.875C10.0737 18.422 10.2933 18.9466 10.6841 19.3334C11.075 19.7202 11.6051 19.9375 12.1579 19.9375Z"
                                fill="currentColor"
                            />
                        </svg>
                    </Circle>
                    <Circle goal={goal} setBadgeType={setBadgeType} index={3}>
                        <svg
                            width="33"
                            height="22"
                            viewBox="0 0 33 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.82105 13.0625L2.77895 11H10.0737L9.24 8.9375H2.43158L1.38947 6.875H12.2274L11.3937 4.8125H1.19495L0 2.75H5.21053C5.21053 2.02065 5.50331 1.32118 6.02446 0.805456C6.54561 0.289731 7.25245 0 7.98947 0H24.6632V5.5H28.8316L33 11V17.875H30.2211C30.2211 18.969 29.7819 20.0182 29.0002 20.7918C28.2184 21.5654 27.1582 22 26.0526 22C24.9471 22 23.8868 21.5654 23.1051 20.7918C22.3234 20.0182 21.8842 18.969 21.8842 17.875H16.3263C16.3263 18.969 15.8871 20.0182 15.1054 20.7918C14.3237 21.5654 13.2634 22 12.1579 22C11.0524 22 9.99211 21.5654 9.21038 20.7918C8.42865 20.0182 7.98947 18.969 7.98947 17.875H5.21053V13.0625H3.82105ZM26.0526 19.9375C26.6054 19.9375 27.1355 19.7202 27.5264 19.3334C27.9173 18.9466 28.1368 18.422 28.1368 17.875C28.1368 17.328 27.9173 16.8034 27.5264 16.4166C27.1355 16.0298 26.6054 15.8125 26.0526 15.8125C25.4999 15.8125 24.9697 16.0298 24.5789 16.4166C24.188 16.8034 23.9684 17.328 23.9684 17.875C23.9684 18.422 24.188 18.9466 24.5789 19.3334C24.9697 19.7202 25.4999 19.9375 26.0526 19.9375ZM28.1368 7.5625H24.6632V11H30.8602L28.1368 7.5625ZM12.1579 19.9375C12.7107 19.9375 13.2408 19.7202 13.6317 19.3334C14.0225 18.9466 14.2421 18.422 14.2421 17.875C14.2421 17.328 14.0225 16.8034 13.6317 16.4166C13.2408 16.0298 12.7107 15.8125 12.1579 15.8125C11.6051 15.8125 11.075 16.0298 10.6841 16.4166C10.2933 16.8034 10.0737 17.328 10.0737 17.875C10.0737 18.422 10.2933 18.9466 10.6841 19.3334C11.075 19.7202 11.6051 19.9375 12.1579 19.9375Z"
                                fill="currentColor"
                            />
                        </svg>
                    </Circle>
                </Fragment>
            );
        case 'gift':
            return (
                <Fragment>
                    <Circle goal={goal} setBadgeType={setBadgeType} index={2}>
                        <span style={{ fontSize: '9px' }} className={classNames('mb-1')}>
                            Free Gift
                        </span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className={classNames('w-4 h-4')}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                            />
                        </svg>
                    </Circle>
                    <Circle goal={goal} setBadgeType={setBadgeType} index={3}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className={classNames('w-6 h-6')}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                            />
                        </svg>
                    </Circle>
                </Fragment>
            );
        default:
            return null;
    }
}
